import { useEffect, useState } from "react";
import { siteNav } from "@/mocks/critter";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50">
      {/* top info bar */}
      <div className="bg-foreground-950 text-background-100 hidden md:block">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-1.5 text-[11px]">
          <p className="flex items-center gap-2">
            <i className="ri-radar-line text-accent-400"></i>
            独立思考 · 证据优先 · 讲清利益背后的逻辑
          </p>
          <div className="flex items-center gap-4">
            <a href="#about" className="hover:text-accent-300 whitespace-nowrap">关于我们</a>
            <a href="#contact" className="hover:text-accent-300 whitespace-nowrap">线索投递</a>
          </div>
        </div>
      </div>

      {/* main nav */}
      <div
        className={`transition-colors duration-300 ${
          scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-background-50"
        }`}
      >
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-3.5">
          <a href="#top" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-megaphone-line text-lg"></i>
            </span>
            <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
              呱呱<span className="text-primary-600">爆料</span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {siteNav.slice(1).map((item) => (
              <a
                key={item.id}
                href={item.href}
                className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-2">
            <button
              type="button"
              className="cursor-pointer inline-flex items-center gap-1.5 rounded-md bg-secondary-100 px-3.5 py-2 text-sm font-medium text-foreground-800 hover:bg-secondary-200 transition-colors whitespace-nowrap"
            >
              <i className="ri-search-line text-sm"></i>检索
            </button>
            <a
              href="#contact"
              className="inline-flex items-center gap-1.5 rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-background-50 hover:bg-primary-700 transition-colors whitespace-nowrap"
            >
              <i className="ri-send-plane-line text-sm"></i>投递线索
            </a>
          </div>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开导航"
            className="lg:hidden flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-900 cursor-pointer"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </div>

        {/* mobile panel */}
        {open && (
          <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3">
            <nav className="flex flex-col gap-1">
              {siteNav.slice(1).map((item) => (
                <a
                  key={item.id}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-between rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
                >
                  {item.label}
                  <i className="ri-arrow-right-s-line text-foreground-400"></i>
                </a>
              ))}
              <a
                href="#contact"
                onClick={() => setOpen(false)}
                className="mt-2 rounded-md bg-primary-600 px-3 py-2.5 text-center text-sm font-semibold text-background-50"
              >
                投递线索
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}